import API from "../API";
import { AxiosResponse } from "axios";

export const listEntity = (search: string): Promise<AxiosResponse> =>
  API.get(`/entity/list?search=${search}`);

export const listEntityById = (id: string): Promise<AxiosResponse> =>
  API.get(`/entity/list/${id}`);

export const disabledEntity = (id: string): Promise<AxiosResponse> =>
  API.post(`/entity/deactivate/${id}`);

type EntityCreatePayload = {
  name: string;
  email: string;
  phone: string;
  subtype: string;
  coupon?: any;
  status?: string;
  address: string;
  startContract: string;
  endContract: string;
};

export const createEntity = (
  payload: EntityCreatePayload
): Promise<AxiosResponse> => API.post("/entity/create", payload);

export const editEntity = (
  payload: EntityCreatePayload,
  id: string
): Promise<AxiosResponse> => API.put(`/entity/edit/${id}`, payload);
